 <div class="casePnlBox">
      <div class="case-header">
        <h3 ><img alt="entity" src="../../../../assets/icons/hitl-icon.svg" /> HITL</h3>
        <div class="refreshIcon">
          <i class="fa fa-refresh view-details"  (click)="getDataAfterRunHITL()"></i>
          <!-- <a href="#" onclick="return false;" class="view-details"><img src="../../../../assets/cocoonImages/view-icon.svg" alt="View Icon"></a> -->
        </div>
      </div>
          <div class="chatCnt chatScrollContant"  [style.height.px]="containerHeight + 350" >
            <div class="createBtnInner mb-3" *ngFor="let data of GetHumanInLoopList" >
                <button 
                (click)="runNowHITL(data)"><img alt="entity" src="../../../../assets/icons/automation_sml.svg" /><ob-ng-tooltip [data]="data.businessActivityName"
                    [size]="30"></ob-ng-tooltip></button>
            </div>
            <div class="mb-3">
              <!-- <div class="row mb-5">
                  <div class="col-md-8 col-sm-6 col-xs-12 noLeftPadding">
                      <h2 class="caseDetailTitle">Human in the loop </h2>
                  </div>
                  <div class="col-md-4 col-sm-6 col-xs-12 text-right noRightPadding">
                      <button id="refresh-caseFields-customization" type="button" class="createBtn" style="margin-right: 0px !important;"
                          (click)="getDataAfterRunHITL()">
                          <i class="fa fa-refresh"></i>Refresh</button>
                  </div>
              </div> -->
              <div class="mainWhiteBoxPading noPaddingZero marginBtmCaseDetail">
                  <div class="card styleTableCT noPaddingBorder" *ngFor="let item of workItemList">
                    <div class="work-item-card">
                      <div class="work-item-icon">
                        <img [alt]="item.workItemType" [src]="getWorkItemIcon(item)" />
                      </div>
                      <div class="work-item-content">
                        <div class="work-item-id">
                          <a (click)="navigateToWorkItem(item)" class="work-item-link">{{item.id}}</a>
                        </div>
                        <div class="work-item-name">{{item.name}}</div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="workItemList.length === 0" class="no-work-items">
                    No Work Items found
                  </div>
              </div>
          </div>
          </div>
        </div>